var map = {
	"./01.jpg": 83,
	"./02.jpg": 84,
	"./03.jpg": 85,
	"./04.jpg": 86,
	"./05.jpg": 87,
	"./06.jpg": 88,
	"./07.jpg": 89,
	"./08.jpg": 90,
	"./09.jpg": 91,
	"./10.jpg": 92,
	"./11.jpg": 93,
	"./12.jpg": 94,
	"./13.jpg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;